import { ChangeDetectionStrategy, Component, ElementRef, OnDestroy, Renderer2 } from '@angular/core';
import { PlantlifeCheapWeedBusinessCardStackContentViewModel } from './plantlife-cheap-weed-business-card-stack-content-view-model';
import { PlantlifeBusinessCardStackSharedLogicContentComponent } from '../plantlife-business-card-stack-shared-logic-content.component';

@Component({
  selector: 'app-plantlife-cheap-weed-business-card-stack-content',
  templateUrl: './plantlife-cheap-weed-business-card-stack-content.component.html',
  styleUrls: ['./plantlife-cheap-weed-business-card-stack-content.component.scss'],
  providers: [PlantlifeCheapWeedBusinessCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PlantlifeCheapWeedBusinessCardStackContentComponent
  extends PlantlifeBusinessCardStackSharedLogicContentComponent
  implements OnDestroy
{
  constructor(
    override viewModel: PlantlifeCheapWeedBusinessCardStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
  }
}
